import { render, staticRenderFns } from "./BpmnViewer.vue?vue&type=template&id=05c506f3&scoped=true"
import script from "./BpmnViewer.vue?vue&type=script&lang=js"
export * from "./BpmnViewer.vue?vue&type=script&lang=js"
import style0 from "./BpmnViewer.vue?vue&type=style&index=0&id=05c506f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c506f3",
  null
  
)

export default component.exports